<template>
	<div>
		<el-card>
			<div class="title">{{ form.prize_name }}</div>
			<el-row :gutter="10">
				<el-col :span="12">
					<el-form label-width="400px">
						<el-form-item label="中奖单号: ">
							<div>{{ form.order_sn }}</div>
						</el-form-item>
						<el-form-item label="中奖人姓名: ">
							<div>{{ form.name }}</div>
						</el-form-item>
						<el-form-item label="中奖人手机号: ">
							<div>{{ form.mobile }}</div>
						</el-form-item>
						<el-form-item label="收货地址: ">
							<div>{{ form.address }}</div>
						</el-form-item>
						<el-form-item label="奖品类型: ">
							<div
								v-text="
									form.award_type == 1
										? '优惠券'
										: form.award_type == 2
										? '积分'
										: form.award_type == 3
										? '实物'
										: form.award_type == 4
										? '余额'
										: '谢谢参与'
								"
							></div>
						</el-form-item>
						<el-form-item label="中奖奖品: ">
							<div>{{ form.award_name }}</div>
						</el-form-item>
						<el-form-item label="图片: ">
							<img width="100" :src="form.pic_url" alt="" />
						</el-form-item>
						<el-form-item label="积分: " v-if="form.award_type == 2">
							<div>{{ form.integral }}</div>
						</el-form-item>
						<el-form-item label="余额: " v-if="form.award_type == 4">
							<div>{{ form.balance }}</div>
						</el-form-item>
						<el-form-item label="订单状态: ">
							<el-tag
								:type="
									form.status == 2
										? 'success'
										: form.status == 1
										? 'warning'
										: 'info'
								"
								v-text="
									form.status == 1
										? '提交'
										: form.status == 2
										? '完成'
										: '未发货'
								"
							></el-tag>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="6">
          
        </el-col>
			</el-row>
      <el-button style="margin-left: 50%;" type="primary" @click="$router.back(-1)">返回</el-button>
		</el-card>
	</div>
</template>
<script>
import { winn_detail } from "@/api/vip";
import store from "@/store/index";
export default {
	data() {
		return {
			form: {},
		};
	},
	mounted() {
		this.get_info();
	},
	methods: {
		async get_info() {
			const res = await winn_detail({
				app_id: store.getters.app_id,
				id: this.$route.query.id,
			});
			if (res.code == 200) {
				this.form = res.data;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
  .title{
    width: 100%;
    height: 5vw;
    line-height: 5vw;
    text-align: center;
    font-size: 3em;
    font-weight: bold;
  }
</style>
